import { Colour_Tournament } from "./Utils";

export class MatchStats {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "MatchStats";
    this.scene = "MatchStats";
    this.data = [];
    this.page = 7053;
  }

  async preview({ options }) {
    this.onAir = false;
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });

      xml.payload.field.find((item) => {
        return item.attr.name === "0000104";
      }).value = "Match Stats";

      xml.payload.field.find((item) => {
        return item.attr.name === "0004";
      }).value = "4";

      xml.payload.field.find((item) => {
        return item.attr.name === "006";
      }).value =
        options.game?.home_team?.variables?.alt_badge ||
        options.game?.home_team?.variables?.badge;

      xml.payload.field.find((item) => {
        return item.attr.name === "007";
      }).value =
        options.game?.away_team?.variables?.alt_badge ||
        options.game?.away_team?.variables?.badge;

      xml.payload.field.find((item) => {
        return item.attr.name === "0101";
      }).value = "Possession";

      xml.payload.field.find((item) => {
        return item.attr.name === "0102";
      }).value =
        (options?.game?.opta_home_team_stats?.["possession"] || 0) + "%";

      xml.payload.field.find((item) => {
        return item.attr.name === "0103";
      }).value =
        (options?.game?.opta_away_team_stats?.["possession"] || 0) + "%";

      xml.payload.field.find((item) => {
        return item.attr.name === "0201";
      }).value = "Completion rate";

      let home_total =
        parseInt(options?.game?.opta_home_team_stats?.["complete_sets"] || 0) +
        parseInt(options?.game?.opta_home_team_stats?.["incomplete_sets"] || 0);

      xml.payload.field.find((item) => {
        return item.attr.name === "0202";
      }).value =
        Math.floor(
          ((options?.game?.opta_home_team_stats?.["complete_sets"] || 0) /
            home_total) *
            100,
        ) + "%";

      let away_total =
        parseInt(options?.game?.opta_away_team_stats?.["complete_sets"] || 0) +
        parseInt(options?.game?.opta_away_team_stats?.["incomplete_sets"] || 0);

      xml.payload.field.find((item) => {
        return item.attr.name === "0203";
      }).value =
        Math.floor(
          ((options?.game?.opta_away_team_stats?.["complete_sets"] || 0) /
            away_total) *
            100,
        ) + "%";

      xml.payload.field.find((item) => {
        return item.attr.name === "0301";
      }).value = "Metres";

      xml.payload.field.find((item) => {
        return item.attr.name === "0302";
      }).value = (options?.game?.opta_home_team_stats?.["metres"] || 0) + "m";

      xml.payload.field.find((item) => {
        return item.attr.name === "0303";
      }).value = (options?.game?.opta_away_team_stats?.["metres"] || 0) + "m";

      xml.payload.field.find((item) => {
        return item.attr.name === "0401";
      }).value = "PTBs in opp. 20";

      xml.payload.field.find((item) => {
        return item.attr.name === "0402";
      }).value = options?.game?.opta_home_team_stats?.["ptb_opp_20m"] || 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0403";
      }).value = options?.game?.opta_away_team_stats?.["ptb_opp_20m"] || 0;

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
